import { render } from "./Mobile.vue?vue&type=template&id=50d5b0b0&scoped=true"
import script from "./Mobile.vue?vue&type=script&lang=js"
export * from "./Mobile.vue?vue&type=script&lang=js"

import "./Mobile.vue?vue&type=style&index=0&id=50d5b0b0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-50d5b0b0"

export default script